/**
 * Outlook OAuth Service
 * Handles the new server-side OAuth flow for Outlook login
 */

// Remove trailing slash from API_BASE_URL to avoid double slashes
const getApiBaseUrl = () => {
  const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:3000/dev/api";
  return baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
};

/**
 * Initiate Outlook OAuth login
 * This redirects the user to Microsoft's authorization endpoint
 */
export const initiateOutlookLogin = () => {
  const loginUrl = `${getApiBaseUrl()}/outlook/login`;
  console.log("🔐 Initiating Outlook OAuth login...");
  console.log("   Redirecting to:", loginUrl);
  
  // Redirect to backend endpoint which will redirect to Microsoft
  window.location.href = loginUrl;
};

/**
 * Check if there's an error in the URL parameters
 * Used on the login page to display OAuth errors
 */
export const getOAuthError = () => {
  const params = new URLSearchParams(window.location.search);
  const error = params.get("error");
  const errorDescription = params.get("error_description");
  
  if (error) {
    return {
      error,
      errorDescription: errorDescription || "Authentication failed",
    };
  }
  
  return null;
};

export default {
  initiateOutlookLogin,
  getOAuthError,
};


